// @ts-nocheck
/**
 * @class Cookies
 * @author Felix Albroscheit
 *
 * Generic handler for managing cookies in the browser
 * Shall be replaced by a more powerful adapter (localStorage, etc.)
 * NOT related to https://www.npmjs.com/package/cookies
 *
 * @TODO Work with adapters (was: Cookie, is: LocalStorage)
 * @TODO Needs tests, functions shall return promise
 * @TODO encrypt / decrypt to hide from grabbers eyes
 *       (e.g. https://www.codeproject.com/Questions/986983/encryption-using-javascript-without-any-external-l)
 */

export default new (class {
  /**
   * @return {bool} Does browser have any cookies?
   */
  documentHasCookies() {
    return document.cookie != "";
  }

  /**
   * @function get
   *
   * @param {String} key
   * @return {String}
   */
  get(key: any): any {
    const name: string = key + "=",
      cookies = decodeURIComponent(document.cookie).split(";"),
      decode = function (s: any): any {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      };

    for (let i: number = 0; i < cookies.length; i++) {
      let c: any = decode(cookies[i]);

      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  /**
   * @function set
   * Sets a cookie for a certain period
   *
   * @param {String} key
   * @param {*} val
   * @param {int} exdays Period in days to be left in storage
   *
   * @return this
   */
  set(key: any, val: any, exdays: number = 30): this {
    val = encodeURIComponent(String(val)).replace(
      /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
      decodeURIComponent,
    );

    key = encodeURIComponent(String(key))
      .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
      .replace(/[\(\)]/g, escape);

    const d = new Date();

    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    document.cookie = key + "=" + val + ";expires=" + d.toUTCString() + ";path=/";

    return this;
  }

  /**
   * @function delete
   * Delete a single cookie by its name
   *
   * @thanks https://stackoverflow.com/questions/179355/clearing-all-cookies-with-javascript
   *
   * @param {String} key
   *
   * @return this
   */
  delete(key: any): this {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    return this;
  }

  /**
   * @function deleteAll
   * Delete all cookies in sope
   *
   * @thanks https://stackoverflow.com/questions/179355/clearing-all-cookies-with-javascript
   */
  deleteAll(): void {
    const cookies = document.cookie.split(";");

    for (let c: number = 0; c < cookies.length; c++) {
      let d: any = window.location.hostname.split(".");

      while (d.length > 0) {
        const cookieBase =
          encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
          "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
          d.join(".") +
          " ;path=";
        let p: any = location.pathname.split("/");
        document.cookie = cookieBase + "/";

        while (p.length > 0) {
          document.cookie = cookieBase + p.join("/");
          p.pop();
        }

        d.shift();
      }
    }
  }
})();
